import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

// 好友申请状态
const APPLY_STATUS = {
	PENDING: 0,   // 待处理
	AGREED: 1,    // 已同意
	REJECTED: 2,  // 已拒绝
	EXPIRED: 3    // 已过期
}

export default defineStore('friendApplyStore', {
	state: () => {
		return {
			applies: [],      // 我收到和发出的全部申请 List<FriendApplyVO>
			unreadCount: 0    // 我收到的待处理且未读的申请数量
		}
	},
	actions: {
		// 加载申请列表(包含我收到和发出的)
		async loadApply() {
			this.applies = await http({ url: '/friend/apply/list' });
		},
		// 刷新未读数量
		async loadUnread() {
			this.unreadCount = await http({ url: '/friend/apply/unread' });
		},
		// 发起好友申请,返回 true 表示因双向申请已直接成为好友
		async sendApply(friendId, remark, source) {
			return await http({
				url: '/friend/apply/send',
				method: 'post',
				data: {
					friendId: friendId,
					remark: remark,
					source: source
				}
			});
		},
		// 处理好友申请 accept=true 同意 / false 拒绝
		async handleApply(applyId, accept) {
			await http({
				url: '/friend/apply/handle',
				method: 'put',
				data: {
					applyId: applyId,
					accept: accept
				}
			});
		},
		// 标记全部已读
		async readAll() {
			await http({ url: '/friend/apply/read', method: 'put' });
			this.unreadCount = 0;
		},
		clear() {
			this.applies = [];
			this.unreadCount = 0;
		}
	}
});

export { APPLY_STATUS };
